import { useMemo, useEffect } from 'react';

import Lineups from '@shared/match-summary/Lineups';
import useMatch from '@shared/MatchUnit/useMatch';
import { matchLineupsAvailable } from '@utilities/live';

const toggleSquadListVisibility = (container: Element | null, isVisible: boolean) => {
  if (!container) return;
  container.classList.toggle('hidden', isVisible);
};

const dispatchResizeEventIfNeeded = (isVisible: boolean) => {
  if (isVisible) return;

  const segmentedControl = document.querySelector<HTMLPkSegmentedControlElement>('.squad-segmented-control');
  if (!segmentedControl) return;

  window.dispatchEvent(new Event('resize'));
};

const MatchLineup = ({ options }) => {
  const match = useMatch(options.matchOptions.match);

  const modulesOptions = useMemo(
    () => ({
      ...options,
      match,
    }),
    [match, options],
  );

  const lineupsAvailable = useMemo(() => matchLineupsAvailable(match), [match]);

  useEffect(() => {
    const squadListContainer = document.querySelector('.js-squadlist-container');
    toggleSquadListVisibility(squadListContainer, lineupsAvailable);
    dispatchResizeEventIfNeeded(lineupsAvailable);
  }, [lineupsAvailable]);

  return lineupsAvailable ? <Lineups options={modulesOptions} /> : null;
};

export default MatchLineup;
